import { Component } from "@angular/core";
import { CustomCookieServiceService } from "../../services/custom-cookie-service.service";
import { PopupService, PwaService, AuthService } from "../../services";

import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-install-pwa-dialog",
  imports: [TranslateModule],
  templateUrl: "./install-pwa-dialog.component.html",
  styleUrl: "./install-pwa-dialog.component.scss",
})
export class InstallPwaDialogComponent {
  constructor(
    private pwaInstallService: PwaService,
    private popupService: PopupService,
    private cookieService: CustomCookieServiceService,
    private authService: AuthService,
  ) {}

  downloadPwa() {
    this.pwaInstallService
      .triggerInstallPrompt()
      .then((result) => {
        if (result) {
          this.closeDialog();
        }
      })
      .catch((error) => {});
  }

  closeDialog() {
    // Set expiration: 90 days for students, 30 days for tutors
    const expirationDays = this.authService.isTeacher() ? 30 : 90;
    this.cookieService.put("pwa-install-dismissed", "true", {
      expires: expirationDays,
      path: "/",
      sameSite: "Lax",
    });
    this.popupService.onClose.emit();
  }
}
